import { action } from "@storybook/addon-actions";
import { ComponentMeta, ComponentStory } from "@storybook/react";
import { Circle } from "lucide-react";
import React from "react";
import Flex from "../Flex";
import { Button, ButtonProps } from "./Button";

const commonArgs: ButtonProps = {
    trackName: "button",
    loading: false,
    title: "Button CTA",
    disabled: false,
    onClick: action("clicked")
};

export default {
    title: "common/Buttons/Button",
    component: Button,
    args: commonArgs
} as ComponentMeta<typeof Button>;

const Template: ComponentStory<typeof Button> = args => {
    return (
        <Flex spacing={1} alignItems="center">
            <Button {...args} variant="primary" />
            <Button {...args} variant="secondary" />
            <Button {...args} variant="tertiary" />
        </Flex>
    );
};

export const Text = Template.bind({});

export const TextIcon = Template.bind({});
TextIcon.args = {
    icon: <Circle />
};

export const IconOnly = Template.bind({});
IconOnly.args = {
    title: undefined,
    icon: <Circle />
};

export const TextDisabled = Template.bind({});
TextDisabled.args = {
    disabled: true
};

export const TextLoading = Template.bind({});
TextLoading.args = {
    loading: true
};

export const DestructiveText = Template.bind({});
DestructiveText.args = {
    destructive: true
};

export const DestructiveTextIcon = Template.bind({});
DestructiveTextIcon.args = {
    ...DestructiveText.args,
    icon: <Circle />
};

export const DestructiveIconOnly = Template.bind({});
DestructiveIconOnly.args = {
    ...DestructiveText.args,
    title: undefined,
    icon: <Circle />
};

export const DestructiveTextDisabled = Template.bind({});
DestructiveTextDisabled.args = {
    ...DestructiveText.args,
    disabled: true
};

export const DestructiveTextLoading = Template.bind({});
DestructiveTextLoading.args = {
    ...DestructiveText.args,
    loading: true
};

export const WithTooltip = Template.bind({});
WithTooltip.args = {
    tooltip: "Tooltip text"
};

const SizesTemplate: ComponentStory<typeof Button> = args => {
    return (
        <Flex spacing={1} alignItems="center">
            <Button {...args} size="lg" />
            <Button {...args} size="md" />
            <Button {...args} size="sm" />
        </Flex>
    );
};

export const Sizes = SizesTemplate.bind({});
Sizes.args = {
    icon: <Circle />
};

export const Inverse: ComponentStory<typeof Button> = args => {
    return (
        <Flex spacing={1} alignItems="center" backgroundColor="primary-1200" p={16}>
            <Button {...args} variant="tertiary-inverse" size="lg" />
            <Button {...args} variant="tertiary-inverse" size="md" />
            <Button {...args} variant="tertiary-inverse" size="sm" />
        </Flex>
    );
};
